import { IPreviewEntity, ModelConfig } from '../types/product';

const getViewerConfig = (currentProduct: IPreviewEntity): ModelConfig => {
    return {
        id: currentProduct.fsn,
        disableOnboarding: true,
        model: {
            url: currentProduct.url
        },

        featureFlags: {
            sizeCompare: true
        },
        camera: {
            behaviors: {
                autoRotate: false
            },
            alpha: 4.7,
            beta: 1.53
        },
        framingBehaviour: 'tight'
    };
};

export { getViewerConfig };
